import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '@/app/store';
import { toggleTheme } from './themeSlice';
import { useTranslation } from 'react-i18next';

export const ThemeToggle: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const themeMode = useAppSelector(state => state.theme.mode);

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  return (
    <Tooltip
      title={t(
        themeMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'
      )}
    >
      <IconButton
        onClick={handleToggle}
        color="inherit"
        aria-label={t(
          themeMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'
        )}
      >
        {themeMode === 'light' ? <DarkMode /> : <LightMode />}
      </IconButton>
    </Tooltip>
  );
};
